import React from 'react';
import { useSavedListNewBadge } from '../hooks/useSavedListNewBadge';

export default (ChildComponent) => {
    const WithSavedListNewBadge = (props) => {
        const showSavedListsNewBadge = useSavedListNewBadge();
        return (<ChildComponent {...props} showSavedListsNewBadge={showSavedListsNewBadge} />);
    };

    WithSavedListNewBadge.displayName = `WithSavedListNewBadge(${ChildComponent.displayName || ChildComponent.name || 'Component'})`;

    return WithSavedListNewBadge;
};
